





import { Component, Vue } from "vue-property-decorator";
import feather from "feather-icons";
@Component({
  name: "collapse-button-component",
})
export default class CollapseButtonComponent extends Vue {
  feather = feather;
  mounted() {
    feather.replace();
  }
  setActiveMenu(e) {
    const element = document.getElementsByClassName("open-menu-container")[0];
    if (element) element["style"].left = "-23rem";
    setTimeout(() => {
      this.$store.dispatch("SidebarStore/setActiveMenuAction", e);
    }, 500);
  }
  get isCallOpen() {
    return (
      this.$store.getters["SidebarStore/getOpenCall"] &&
      this.$store.getters["MeetingStore/getColumnDisplay"]
    );
  }
}
